// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_3pgof","text":"index_text_2IDB4","link":"index_link_1MCJT"};